export default __webpack_public_path__ + "static/media/seven.3168c0a5.svg";